import { useTheme } from "@/context/Theme";

export const Logo = ({ variant, compact = false }) => {
  const { theme } = useTheme();
  const v = variant || (theme === "dark" ? "dark" : "light");
  return (
    <span className="flex items-center gap-2" data-testid={`brand-logo-${v}`}>
      <img src={`/brand/gate-${v}.png`} alt="باب اليمن — BAB AL YEMEN" width="80" height="40" className="h-9 sm:h-10 w-auto shrink-0" />
      <img src={`/brand/wordmark-${v}.png`} alt="" width="94" height="40" className={`h-10 sm:h-11 w-auto ${compact ? "hidden sm:block" : ""}`} />
    </span>
  );
};
